<div class="container-fluid psp-container">
    <div class="card mb-4">
      <div class="add-test-container">
        <div class="card-body">
          <div class="card-title">
            <h2>Uploading Tool</h2>
            <div class="divider"></div>
          </div>
          <form [formGroup]="uploadFileForm">
            <div class="row justify-content-between">
                <div class="col-md-4">
                  <label class="form-control-label required" for="file">
                      File Type
                  </label>
                  <select
                    class="form-control"
                    id="fileTypeId"
                    formControlName="fileTypeId"
                  >
                    <option [ngValue]="null" [disabled]="true" >Select File Type</option>
                    <option *ngFor="let fileType of excelTemplates" [ngValue]="fileType.id">
                      {{ fileType.name }}
                    </option>
                  </select>
                </div>
                <div class="col-md-4">
                    <label class="form-control-label required" for="file">
                        File
                    </label>
                    <input
                        formControlName="file"
                        class="form-control"
                        id="file"
                        type="file"
                        name="test-files"
                        lang="en"
                        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    />
                </div>
                <div class="form-actions col-md-2">
                  <button
                    class="btn next-btn"
                    (click)="submit()"
                    [disabled]="uploadFileForm.invalid"
                  >
                    Submit
                  </button>
                </div>
                <div class="form-actions col-md-2">
                  <button
                    class="btn next-btn tex"
                    (click)="downloadTemplate()"
                    [disabled]="!uploadFileForm.value.fileTypeId"
                  >
                    Download
                  </button>
                </div>
            </div>
          </form>
        </div>
      </div>
    </div>
</div>
